<template>
  <div class="trainingDetail">
    <div id="trainingDetail">

      <div ref="videobox" id="mui-player"></div>

      <div class="top-content">
        <div class="van-card">
          <!--          <van-button v-for="(item, index) in data.sampleCourses"-->
          <!--                      :class="courseId == item.id ? 'active' : ''"-->
          <!--                      class="type-button"-->
          <!--                      @click="onSampleCourses(item.id)">-->
          <!--            {{ item.name }}-->
          <!--          </van-button>-->
        </div>
        <div class="remark">
          <div class="title">{{ data.name }}</div>
          <div class="content">{{ data.remark }}</div>

          <div class="content-tag">
            <van-tag round>{{ data.studyCount }}人已学习</van-tag>
            <van-tag round>观看结束获得{{ data.classHour }}学时</van-tag>
          </div>

          <div class="title">选集</div>

          <div class="list-content">
            <van-tag :class="id === item.id ? 'active' : ''" round @click="clickInfo(item.id)"
                     v-for="(item, index) in data.videos">
              {{ index < 9 ? '0' + (index + 1) : index + 1 }}
            </van-tag>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getNum } from '@api/activity'
import { courseDetail, videoEnd } from '@api/train'
import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'

export default {
  name: 'trainingDetail',
  data () {
    return {
      time: false,
      autoplay: true,
      state: false,
      currTime: null,
      maxTime: 0,
      tipShow: false,
      data: {},
      videoUrl: '',
      coursesId: '',
      id: ''
    }
  },
  created () {
    this.token = localStorage.getItem('token')
    this.courseId = this.$route.query.id
    this.id = this.$route.query.id
    this.typeId = this.$route.query.typeId
    this.contentDetail()
    // this.courseId = this.$route.query.courseId
    // this.contentDetail()
  },
  watch: {},
  mounted () {
    // 延迟1秒
    setTimeout(() => {
      // 监听视频是否播放完毕
      if (!this.state) {
        document.querySelector('video').loop = false // 不设置视频循环播放;
        document.querySelector('video').addEventListener('ended', () => { //该视频播放是否已结束
          this.state = true
          this.videoEnd()
        }, false)
      }
    }, 2000)

    if (this.token && this.token !== 'undefined') {
      if (this.typeId == 19) {
        this.getNum()
      }
    }
  },

  methods: {

    // 参与金币活动
    getNum () {
      getNum().then(res => {
        if (res.data.code === 200) {
          if (res.data.data) {
            setTimeout(() => {
              const data = {
                title: '学安全知识 送万元金币',
                url: `${process.env.VUE_APP_BASE_HOST}/activity/cashVideo`
              }
              this.$bridge.callHandler('newPage', data, response => {
                console.log('response:', response)
              })
            }, 1000)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 查看详情
    clickInfo (id) {
      if (id == this.id) {
        return
      }
      this.id = id
      this.updateVideo()
    },

    // 视频播放完调用
    videoEnd () {
      videoEnd({ id: this.id, courseId: this.courseId }).then(res => {
        if (res.data.code === 200) {
          this.content = res.data.data
          if (this.content.nextVideo) {
            this.id = this.content.nextVideo.id

            let message = '本视频已学完！'
            if (this.content.info) {
              message = this.content.info
            }
            this.$dialog.confirm({
              title: '提示',
              message: message,
              confirmButtonColor: '#0368C1FF',
              confirmButtonText: '继续学习'
            }).then(() => {
              // on confirm
              this.updateVideo()
            })
              .catch(() => {
                // on cancel
              })
          } else {
            let message = '本课程已学完！'
            if (this.content.info) {
              message = this.content.info
            }
            this.$dialog.alert({
              title: '提示',
              message: message,
              confirmButtonColor: '#0368C1FF',
              confirmButtonText: '确定'
            }).then(() => {
              // on confirm

            })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    updateVideo () {
      for (let i = 0; i < this.videos.length; i++) {
        if (this.id == this.videos[i].id) {
          this.videoUrl = this.videos[i].videoUrl

          // 初始化 MuiPlayer 插件，MuiPlayer 方法传递一个对象，该对象包括所有插件的配置
          var mp = new MuiPlayer({
            container: '#mui-player',
            title: '视频',
            src: this.videoUrl,
            preload: 'auto',
            autoplay: true,
            videoAttribute: [
              {
                attrKey: 'webkit-playsinline',
                attrValue: false
              }, {
                attrKey: 'playsinline',
                attrValue: false
              }
            ]
          })

          // this.$forceUpdate()
          return
        }
      }
    },

    timeupdate (e) {
      console.log(e.srcElement.currentTime - this.currTime)
      if (e.srcElement.currentTime - this.currTime > 1) {
        e.srcElement.currentTime = this.currTime > this.maxTime ? this.currTime : this.maxTime
        // 拒绝接标成功之后的反馈
        this.$dialog.alert({
          title: '提示',
          message: '请认真学习哦！',
        }).then(() => {
        })
      }
      this.currTime = e.srcElement.currentTime
      this.maxTime = this.currTime > this.maxTime ? this.currTime : this.maxTime
    },
    // 监听视频暂停
    cPause () {
      if (this.timer) {
        clearTimeout(this.timer) // 暂停的时候关闭定时器
      }
    },

    // 禁止视频快进
    cannotSpeed () {
      let sym
      let video = this.$refs.videobox // 获取到video
      setInterval(function () {
        let time = video.currentTime
        if (time - sym > 1) {
          video.currentTime = sym
        }
        sym = video.currentTime
      }, 500)
    },

    // 课程点击
    onSampleCourses (id) {
      if (id == this.courseId) {
        return
      }
      this.courseId = id
      this.contentDetail()
    },

    // 获取详情
    contentDetail () {
      courseDetail({
        id: this.courseId
      }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
          this.videos = res.data.data.videos
          this.id = res.data.data.videos[0].id
          this.updateVideo()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

#mui-player {
  height: 200px !important;
}

.trainingDetail {
  /*height: 100%;*/
  min-height: 100%;
  padding-bottom: 80px;

  .btn-div {
    text-align: center;
    position: fixed;
    bottom: 20px;
    width: 100%;
    z-index: 99;
  }

  .top-content {

    .remark {
      border-bottom: 0.5px solid white;
      padding: 0 10px 10px 10px;
      background-color: white;

      .title {
        @include add_size($font_size_16);
        font-weight: bold;
        padding: 10px 0;
      }

      .content {
        @include add_size($font_size_14);
      }

      .content-tag {
        padding-top: 10px;
        font-size: 1px;

        .van-tag {
          background-color: #EEEEEEFF;
          color: #999999FF;
          @include add_size($font_size_12);
          padding: 4px 12px;
          margin: 0 10px 10px 0;
        }
      }
    }

    .van-card {
      background-color: white;
      padding: 10px 10px 0 10px;

      .type-button {
        height: 35px;
        margin: 0 10px 10px 0;
        color: #333333FF;
        @include add_size($font_size_15);
        padding: 5px 12px;
        background-color: #EFF5FEFF;
        border-radius: 5px;
      }

      .active {
        color: #FFFFFFFF;
        background-color: #096CEFFF;
      }
    }

    .van-card__content {
      min-height: 0;
    }

    .van-card__thumb {
      height: 80px;
      width: 80px;
    }

    .card-title {
      font-weight: bold;
      @include add_size($font_size_18);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; //控制行数
      overflow: hidden;
    }

    .card-introduce {
      color: #999999;
      @include add_size($font_size_16);
      padding: 2px 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; //控制行数
      overflow: hidden;
    }

    .content-ft {
      @include add_size($font_size_16);
    }
  }

  .list-content {
    font-size: 1px;
    padding-top: 4px;

    .van-tag {
      background-color: #EEEEEEFF;
      color: #999999FF;
      @include add_size($font_size_14);
      padding: 6px 24px;
      margin-bottom: 10px;
      margin-right: 10px;
    }

    .active {
      background-color: #37A1FFFF;
      color: #FFFFFFFF;
    }
  }
}
</style>
